module.exports = __webpack_public_path__ + "media/country_flags/pa-713115e1.png";